export enum CompanyRepresentativeStatus {
    REQUESTED,
    ACTIVE,
    DECLINED,
    SUSPENDED,
  }  